import { Case } from "../models/case.model";

export const CASES: Case[] = [
  {
    'fileName': 'case-01.jpg',
    'name': 'Amy 王',
    'achieveDesc': '录取学校:',
    'achievements': ['康奈尔大学','密歇根大学安娜堡分校'],
    'bgDesc': '语言成绩:',
    'backgrounds': ['TOEFL 104','SAT 2020'],
    'projects': ['绿宝石训练营 ','实操工坊']
  },
  {
    'fileName': 'case-02.jpg',
    'name': 'Michelle 高',
    'achieveDesc': '录取学校:',
    'achievements': ['斯坦福大学','加州大学伯克利分校'],
    'bgDesc': '语言成绩:',
    'backgrounds': ['TOEFL 103','SAT 阅读720 数学780'],
    'projects': ['实操工坊']
  },
  {
    'fileName': 'case-06.jpg',
    'name': 'Alex 王',
    'achieveDesc': '项目成果:',
    'achievements': ['宾夕法尼亚大学','麦肯锡社团'],
    'bgDesc': '学业背景:',
    'backgrounds': ['宾夕法尼亚大学','沃顿商学院'],
    'projects': ['实操工坊']
  },
  {
    'fileName': 'case-04.jpg',
    'name': 'Lisa 苏',
    'achieveDesc': '项目成果:',
    'achievements': ['JPMorgan','全职Offer'],
    'bgDesc': '学业背景:',
    'backgrounds': ['福特汉姆大学','金融学本科'],
    'projects': ['实操工坊','职场敲门砖']
  },
  {
    'fileName': 'case-07.jpg',
    'name': 'Shawn 董',
    'achieveDesc': '项目成果:',
    'achievements': ['精品投行全职Offer','研究生Offer'],
    'bgDesc': '学业背景:',
    'backgrounds': ['UCLA','数学本科'],
    'projects': ['蓝宝石训练营','职场敲门砖']
  },
  {
    'fileName': 'case-03.jpg',
    'name': 'Lena 钟',
    'achieveDesc': '项目成果:',
    'achievements': ['OgiIvy奥美公关','全职offer'],
    'bgDesc': '学业背景:',
    'backgrounds': ['NYU','公共关系学硕士'],
    'projects': ['实操工坊','职场敲门砖']
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/cases.ts